<template>
	<CHeaderLayout @show-account-menu="$emit('show-account-menu')">
		<template #title>
			<h1>Usage</h1>
		</template>

		<main class="organization-settings-usage">
			<OrganizationUsageView
				:usage-data="usageData"
				:org-code="orgCode"
				:usage-loading="usageLoading"
				:forms-loading="formsLoading"
				@month-year-change="onMonthYearChange"
			/>
		</main>
	</CHeaderLayout>
</template>

<script lang="ts">
	import { defineComponent, onMounted, reactive, ref } from 'vue';
	import { getOrganizationUsage, getOrganizationUsageByMonthYear } from '@cognitoforms/api/services/settings/organization-settings-service';
	import type { UsageViewModel } from '@cognitoforms/types/server-types/model/organization-settings/usage-view-model';
	import CHeaderLayout from 'src/components/app/HeaderLayout.vue';
	import OrganizationUsageView from './OrganizationUsageView.vue';
	import sessionConsumer from 'src/mixins/session-consumer';

	export default defineComponent({
		components: {
			CHeaderLayout,
			OrganizationUsageView
		},
		mixins: [sessionConsumer],
		setup(props, { emit }) {
			onMounted(() => emit('component-loaded'));
			return {
				usageData: reactive<UsageViewModel>({
					Month: null,
					Items: [],
					FormsUsage: [],
					CurrentBalance: null,
					DashboardNotifications: null
				} as UsageViewModel),
				usageLoading: ref(true),
				formsLoading: ref(true),
				orgCode: ref(null)
			};
		},
		head() {
			return {
				title: 'Usage - Cognito Forms',
				titleTemplate: '%s'
			};
		},
		async mounted() {
			this.usageLoading = true;
			this.formsLoading = true;

			await this.getUsageData();
			this.orgCode = this.session.value.orgCode;

			this.usageLoading = false;
			this.formsLoading = false;
		},
		methods: {
			async onMonthYearChange(payload: { year: number, month: number }) {
				this.usageLoading = true;

				try {
					await this.getUsageDataByMonthYear(payload.year, payload.month);
				}
				finally {
					this.usageLoading = false;
				}
			},
			async getUsageData() {
				Object.assign(this.usageData, await getOrganizationUsage());
			},
			async getUsageDataByMonthYear(year: number, month: number) {
				Object.assign(this.usageData, await getOrganizationUsageByMonthYear(year, month));
			}
		}
	});
</script>

<style lang="scss">
.organization-settings-usage {
	--content-max-width: 1536px;
}
</style>